export const 
REGISTRATION_CHECK_REQUEST = "REGISTRATION_CHECK_REQUEST",
REGISTRATION_CHECK_SUCCESS = "REGISTRATION_CHECK_SUCCESS",
REGISTRATION_CHECK_FAILURE = "REGISTRATION_CHECK_FAILURE";
